export enum TARIFF_CONTEXT {
  NEW_CUSTOMER = 'Neukunde',
  CHANGE = 'Tarifwechsel',
  CHANGE_CHARGEFLEX = 'Chargeflex',
  CHANGE_CAMPAIGN = 'Kampagne',
  CHANGE_PREFILLED = 'TarifwechselVorbefüllt',
  OFFER = 'Angebot',
  MOVE = 'Umzug',
  ADD = 'NeuerVertrag',
  CANCEL = 'Kündigung',
  END = 'Auszug'
}
